import * as React from 'react';

var _path, _g, _defs;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUnichainTestnet = function SvgUnichainTestnet(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip0_1288_4978)"
    }, /*#__PURE__*/ React.createElement("g", {
        clipPath: "url(#clip1_1288_4978)"
    }, /*#__PURE__*/ React.createElement("mask", {
        id: "mask0_1288_4978",
        width: 120,
        height: 120,
        x: 0,
        y: 0,
        maskUnits: "userSpaceOnUse",
        style: {
            maskType: "luminance"
        }
    }, _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M119.74 0H.207v119.533H119.74z"
    }))), _g || (_g = /*#__PURE__*/ React.createElement("g", {
        mask: "url(#mask0_1288_4978)"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M119.74 0H.207v119.533H119.74z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "url(#paint0_radial_1288_4978)",
        d: "M119.74 0H.207v119.533H119.74z"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FDAFF0",
        d: "M12.16 0v119.533M24.113 0v119.533M36.067 0v119.533M48.02 0v119.533M59.973 0v119.533M71.927 0v119.533M83.88 0v119.533M95.833 0v119.533M107.787 0v119.533M119.74 11.953H.207M119.74 23.907H.207M119.74 35.86H.207M119.74 47.813H.207M119.74 59.767H.207M119.74 71.72H.207M119.74 83.673H.207M119.74 95.627H.207M119.74 107.58H.207M59.973 95.393c19.676 0 35.627-15.95 35.627-35.626S79.65 24.14 59.973 24.14c-19.675 0-35.626 15.95-35.626 35.627 0 19.675 15.95 35.626 35.626 35.626Z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M57.405 107.382V12.208h5.136v95.174z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M11.94 57.198h96.067v5.136H11.939z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M62.542 11.953c0 24.99 20.257 45.246 45.246 45.246v5.137c-27.826 0-50.383-22.557-50.383-50.383zM57.405 107.61c0-24.99-20.257-45.247-45.246-45.247v-5.136c27.825 0 50.383 22.557 50.383 50.383z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ React.createElement("path", {
        stroke: "#FDAFF0",
        d: "M119.938 35.86C100.024 35.86 83.88 19.805 83.88 0M.008 83.872c19.915 0 36.059 16.055 36.059 35.86M83.979 119.732c0-19.915 16.055-36.059 35.86-36.059M35.968 0c0 19.915-16.056 36.059-35.86 36.059"
    }))))), _defs || (_defs = /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip0_1288_4978"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 120,
        height: 120,
        fill: "#fff",
        rx: 60
    })), /*#__PURE__*/ React.createElement("clipPath", {
        id: "clip1_1288_4978"
    }, /*#__PURE__*/ React.createElement("rect", {
        width: 120,
        height: 119.533,
        fill: "#fff",
        rx: 59.767
    })), /*#__PURE__*/ React.createElement("radialGradient", {
        id: "paint0_radial_1288_4978",
        cx: 0,
        cy: 0,
        r: 1,
        gradientTransform: "rotate(90 .103 59.87)scale(59.7665)",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ React.createElement("stop", {
        stopColor: "#FC74FE"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: 1,
        stopColor: "#F50DB4"
    })))));
};

export { SvgUnichainTestnet as ReactComponent };
//# sourceMappingURL=UnichainTestnet.svg.es.js.map
